import React from "react";

// Redux
import { useSelector } from 'react-redux';

// Components
import CardLabelComponent from "../../components/CardLabelComponent";
import CardDataLabelComponent from "../../components/CardDataLabelComponent";
import OrderItemComponent from "./OrderItemComponent";

// Services
import { formatterService } from "../../services/formatters.service";

function CartItemsComponent(props) {

    const cart = useSelector((state) => state.cart);

    return (
        <div className="card card-order">
            <div className="card-body">
                <div className="d-flex justify-content-evenly">
                    <div>
                        <CardLabelComponent label="Data:" />
                        <CardDataLabelComponent label={formatterService.formatDate(cart.date)} />
                    </div>
                    <div>
                        <CardLabelComponent label="Período:" />
                        <CardDataLabelComponent label={cart.form.period_text} />
                    </div>
                </div>
                <hr className="smaller-hr"/>
                <OrderItemComponent />
            </div>
        </div>
    );
}

export default CartItemsComponent;